<template>
  <div>
    <div class="container-fluid" style="zoom: 80%">
      <div class="row">
        <div class="col-md-12 mb-2">
          <h3 style="font-weight:700">Account Settings</h3>
        </div>
        <Sidebar :foto="this.photo" />
        <div class="col-md-10 pl-0">
          <div class="card card-box mb-3 " style="border-radius : 0%">
            <div class="card-body">
              <b-form>
                <div class="row">
                  <div class="col-md-12 mt-2 mb-3">
                    <h4 class="__blue" style="font-weight: 700">
                      Fasilitas
                    </h4>
                  </div>
                  <div v-for="(initial, index) in dataFasilitas" :key="index">
                    <div class="col-md-3 mt-3">
                      <b-form-checkbox
                        v-model="dataFasilitas[index].checked"
                        :value="1"
                        unchecked-value="0"
                        :disabled="!hasFeatures('klinik')"
                        @input="onChange($event, index)"
                      >
                        {{ initial.nama }}
                      </b-form-checkbox>
                    </div>
                  </div>

                  <br />
                  <br />
                  <div class="col-md-12 mt-3 mb-2">
                    <hr />
                    <br />
                    <h4 class="__blue mt-1" style="font-weight: 700">
                      Jadwal Dokter
                    </h4>
                  </div>
                  <div
                    class="col-md-12 mt-3 mb-5"
                    v-if="dataJadwal.length != 0"
                  >
                    <div class="row" v-for="data in dataJadwal" :key="data.id">
                      <div class="col-md-2 mt-1">
                        {{ data.nama_poliklinik }}
                      </div>
                      <span class="mt-1">:</span>
                      <div class="col-md-9 mt-1">
                        <div v-for="jadwal in data.jadwal" :key="jadwal.id">
                          {{ jadwal }}
                          <br />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 mb-5" v-else>
                    <label for="">-</label>
                  </div>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {
    Sidebar: () => import("@/views/AccountSettingKlinik/Sidebar")
  },
  data() {
    return {
      status: false,
      dataCheckBox: [],
      initial: 0,
      dataJadwal: null,
      dataFasilitas: null,
      photo: null
    };
  },
  computed: {
    ...mapGetters(["getKlinikId", "getRolesName"])
  },
  mounted() {
    window.scrollTo({
      top: 95,
      behavior: "smooth"
    });

    this.getDataJadwal();
    this.getDataFasilitas();
  },
  methods: {
    async onChange(data, index) {
      try {
        const res = await this.$axios.post(`klinik/fasilitas`, {
          klinik_id: this.getKlinikId,
          fasilitas_id: index + 1,
          checked: data
        });
      } catch (error) {}
    },
    hasFeatures(value) {
      const features = {
        klinik: ["pic_cabang", "pic_pusat"],
        dokter: ["dokter_klinik"],
      };
      const isOwner = features[value].filter(feature => {
        return this.getRolesName.includes(feature);
      });
      return isOwner.length > 0 ? true : false;
    },
    async getDataJadwal() {
      try {
        const res = await this.$axios.get(
          `poliklinik/jadwal?klinik_id=${this.getKlinikId}`
        );

        const { data } = res.data;

        this.dataJadwal = res.data.data;
      } catch (error) {}
    },
    async getDataFasilitas() {
      try {
        const res = await this.$axios.get(
          `klinik/fasilitas?klinik_id=${this.getKlinikId}`
        );
        this.dataFasilitas = res.data.data;
        this.dataCheckBox = this.dataFasilitas;
      } catch (error) {}
    }
  }
};
</script>

<style scoped>
.__blue {
  color: #4b80b6;
}

._outer_klinik_profile {
  cursor: pointer;
}

.__outer_line_profile {
  border-right: rgb(121, 121, 121);
  border-left: none;
  border-top: none;
  border-bottom: none;
  border-right-style: solid;
}

.__icon_add_photo {
  position: absolute;
  top: 12px;
  left: 14px;
}
.__btn_add_photo {
  position: absolute;
  top: 85px;
  right: 15px;
  z-index: 10;
  border-radius: 50%;
  height: 44px !important;
  background-color: rgb(121, 121, 121);
}
.badge-alert {
  background-color: #ffffff;
  border: solid 1px rgba(7, 9, 25, 0.5) !important;
  border-radius: 50%;
  cursor: pointer;
}
</style>
